const PATH = 'fe.pages.double_coding_queue';

const messages = {
  reviewNextButton: {
    key: `${PATH}.review_next_button`,
    defaultValue: 'Review next video'
  },
  educator: {
    key: `${PATH}.educator`,
    defaultValue: 'Educator'
  },
  languagesSpoken: {
    key: `${PATH}.languages_spoken`,
    defaultValue: 'Languages Spoken'
  },
  center: {
    key: `${PATH}.center`,
    defaultValue: 'Center'
  },
  ageLevel: {
    key: `${PATH}.age_level`,
    defaultValue: 'Age Level'
  },
  noVideosMessage: {
    key: `${PATH}.no_videos_message`,
    defaultValue: 'No videos available to review'
  },
  noVideosDescription: {
    key: `${PATH}.no_videos_description`,
    defaultValue:
      'Once we have videos available for you to review they will appear here'
  },
  videoRejectedTitle: {
    key: `${PATH}.video_rejected_title`,
    defaultValue: 'Video rejected'
  },
  videoRejectedDescription: {
    key: `${PATH}.video_rejected_description`,
    defaultValue:
      'The video has been rejected and will no longer appear in your queue.'
  },
  scoresSubmittedTitle: {
    key: `${PATH}.scores_submitted_title`,
    defaultValue: 'Your scores have been submitted'
  },
  scoresSubmittedDescription: {
    key: `${PATH}.scores_submitted_description`,
    defaultValue:
      'Thank you for submitting your scores! Please note that submitted scores are final and cannot be edited.'
  },
  reviewAnoterVideo: {
    key: `${PATH}.review_another_video`,
    defaultValue: 'Review another video'
  },
  review: {
    sidebarTitle: {
      key: `${PATH}.review.sidebar_title`,
      defaultValue: 'To claim this video:'
    },
    sidebarItem1: {
      key: `${PATH}.review.sidebar_item_1`,
      defaultValue:
        'I certify that I have never worked with the educator in this video before'
    },
    sidebarItem2: {
      key: `${PATH}.review.sidebar_item_2`,
      defaultValue:
        'I certify that I have never worked at the center in this video before'
    },
    claimButton: {
      key: `${PATH}.review.claim_button`,
      defaultValue: 'Claim video'
    },
    nextButton: {
      key: `${PATH}.review.next_button`,
      defaultValue: 'Next video'
    }
  },
  scores: {
    submitError: {
      key: `${PATH}.scores.submit_error`,
      defaultValue:
        'An error occurred while submitting your scores. Please try again.'
    },
    title: {
      key: `${PATH}.scores.title`,
      defaultValue: 'Please enter the scores for this video'
    },
    submitScores: {
      key: `${PATH}.scores.submit_scores`,
      defaultValue: 'Submit scores'
    },
    confirmSubmissionTitle: {
      key: `${PATH}.scores.confirm_submission_title`,
      defaultValue: 'Confirm score submission'
    },
    confirmSubmissionDescription: {
      key: `${PATH}.scores.confirm_submission_description`,
      defaultValue:
        "Please make sure all entered scores and ranges are correct. Once you submit them, you won't be able to edit them."
    },
    confirmSubmissionCancelButton: {
      key: `${PATH}.scores.confirm_submission_cancel_button`,
      defaultValue: 'Cancel'
    },
    confirmSubmissionConfirmButton: {
      key: `${PATH}.scores.confirm_submission_confirm_button`,
      defaultValue: 'Confirm and submit'
    },
    returnToQueueButton: {
      key: `${PATH}.scores.return_to_queue_button`,
      defaultValue: 'Return video to queue'
    }
  },
  rejectButton: {
    cancelButton: {
      key: `${PATH}.reject_button.cancel_button`,
      defaultValue: 'Cancel'
    },
    rejectButton: {
      key: `${PATH}.reject_button.reject_button`,
      defaultValue: 'Reject video'
    },
    rejectReasonTitle: {
      key: `${PATH}.reject_button.reject_reason_title`,
      defaultValue: 'Confirm return reason'
    },
    rejectReasonLabel: {
      key: `${PATH}.reject_button.reject_reason_label`,
      defaultValue:
        'Please specify the reason why you are unable to code this video'
    }
  }
};

export default messages;
